import React from "react";
import { ClearableCheckboxDropdown, Table } from "dyl-components";
import { Table as SemanticTable } from "semantic-ui-react";

import { useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import SelectAllCheckbox from "shared/SelectAllCheckbox";
import { PhoneUtil } from "utils";

const DialerColumns = ({ onFilter }) => {
    const [params] = useSearchParams();
    return (
        <>
            <SemanticTable.HeaderCell textAlign="center" className="CampaignContactsTableCell CampaignContactsTableCell--start">
                <ClearableCheckboxDropdown
                    text="Call Result"
                    name="call_result"
                    onChange={(_, { value }) => {
                        onFilter("call_result", value);
                    } }
                    onRead={() => { } }
                    value={params.get("call_result")?.split(",")}
                    options={PhoneUtil.CALL_RESULT_OPTIONS}
                    closeOnLoad />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell textAlign="center" className="CampaignContactsTableCell CampaignContactsTableCell--end">
                <ClearableCheckboxDropdown
                    text="Suspend Call"
                    name="suspend_call"
                    onChange={(_, { value }) => {
                        onFilter("suspend_call", value);
                    } }
                    onRead={() => { } }
                    value={params.get("suspend_call")?.split(",")}
                    options={[
                        {
                            key: "yes",
                            value: "yes",
                            text: "Yes"
                        },
                        {
                            key: "no",
                            value: "no",
                            text: "No"
                        }
                    ]}
                    closeOnLoad />
            </SemanticTable.HeaderCell>
        </>
    );
}

const TextColumns = ({ onFilter, hasCall }) => {
    const [params] = useSearchParams();
    return (
        <>
            <SemanticTable.HeaderCell textAlign="center" className={!hasCall ? "CampaignContactsTableCell CampaignContactsTableCell--start" : ""} width={hasCall ? undefined : 2}>
                <ClearableCheckboxDropdown
                    text="Text Result"
                    name="text_result"
                    onChange={(_, { value }) => {
                        onFilter("text_result", value);
                    } }
                    onRead={() => { } }
                    value={params.get("text_result")?.split(",")}
                    options={[
                        {
                            key: "none",
                            value: "none",
                            text: "None"
                        },
                        {
                            key: "sent",
                            value: "sent",
                            text: "Sent"
                        },
                        {
                            key: "pending",
                            value: "pending",
                            text: "Pending"
                        },
                        {
                            key: "failed",
                            value: "failed",
                            text: "Failed"
                        }
                    ]}
                    closeOnLoad 
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell textAlign="center" width={hasCall ? undefined : 2}>
                <ClearableCheckboxDropdown
                    text="Sent Text"
                    name="sent"
                    onChange={(_, { value }) => {
                        onFilter("sent", value);
                    } }
                    onRead={() => { } }
                    value={params.get("sent")?.split(",")}
                    options={[
                        {
                            key: "yes",
                            value: "yes",
                            text: "Yes"
                        },
                        {
                            key: "no",
                            value: "no",
                            text: "No"
                        }
                    ]}
                    closeOnLoad 
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell textAlign="center" className="CampaignContactsTableCell CampaignContactsTableCell--end" width={hasCall ? undefined : 2}>
                <ClearableCheckboxDropdown
                    text="Text Opt-Out"
                    name="text_optout"
                    onChange={(_, { value }) => {
                        onFilter("text_optout", value);
                    } }
                    onRead={() => { } }
                    value={params.get("text_optout")?.split(",")}
                    options={[
                        {
                            key: "yes",
                            value: "yes",
                            text: "Yes"
                        },
                        {
                            key: "no",
                            value: "no",
                            text: "No"
                        }
                    ]}
                    closeOnLoad 
                />
            </SemanticTable.HeaderCell>
        </>
    );
}   

export const ContactsHeader = () => {
    const { count, contacts = [], isCompanyCampaign, outreachTypes } = useSelector((state) => {
        return {
            count: state.campaign_contacts.count,
            contacts: state.campaign_contacts.contacts.map(
                (campaign_contact) => campaign_contact.contact
            ),
            isCompanyCampaign: state.campaigns.campaign?.is_company_campaign?.start_time,
            outreachTypes: (state.campaigns.campaign?.is_company_campaign?.campaign_type || [])?.slice(0).sort()
        };
    });

    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { id } = useParams();
    const routeRoot = `/campaigns/${id}/contacts`;

    const onFilterByConverted = (filters) => {
        const query = new URLSearchParams(params);
        const noFiltersInPlace = filters.length === 0;
        query.set("page", 1);
        if (noFiltersInPlace) {
            query.delete("converted");
            const query_string = query.toString();
            navigate(`${routeRoot}${query_string ? `?${query_string}` : ""}`);
        } else {
            query.set("converted", filters);
            const query_string = query.toString();
            navigate(`${routeRoot}${query_string ? `?${query_string}` : ""}`);
        }
    };

    const onFilterByStatus = (filters) => {
        const query = new URLSearchParams(params);
        const noFiltersInPlace = filters.length === 0;
        query.set("page", 1);
        if (noFiltersInPlace) {
            query.delete("status");
            const query_string = query.toString();
            navigate(`${routeRoot}${query_string ? `?${query_string}` : ""}`);
        } else {
            query.set("status", filters);
            const query_string = query.toString();
            navigate(`${routeRoot}${query_string ? `?${query_string}` : ""}`);
        }
    }

    const onFilter = (filterName, filters) => {
        const query = new URLSearchParams(params);
        const noFiltersInPlace = filters.length === 0;
        query.set("page", 1);
        if (noFiltersInPlace) {
            query.delete(filterName);
            const query_string = query.toString();
            navigate(`${routeRoot}${query_string ? `?${query_string}` : ""}`);
        } else {
            query.set(filterName, filters);
            const query_string = query.toString();
            navigate(`${routeRoot}${query_string ? `?${query_string}` : ""}`);
        }
    }

    return (
        <Table.Row className="CampaignContactsTableRow">
            <SemanticTable.HeaderCell width={1}>
                <SelectAllCheckbox
                    count={count}
                    data={contacts}
                    type={"contacts"}
                    idProperty={"id"}
                    location="Campaign"
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>
                Contact Name
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={2}>
                <ClearableCheckboxDropdown
                    text="Campaign Converted"
                    name="selectedStatus"
                    onChange={(_, { value }) => {
                        onFilterByConverted(value);
                    }}
                    onRead={() => {}}
                    value={params.get("converted")?.split(",")}
                    options={[
                        { key: "yes", value: "yes", text: "Yes" },
                        { key: "no", value: "no", text: "No" },
                    ]}
                    closeOnLoad
                />
            </SemanticTable.HeaderCell>
            {!isCompanyCampaign ? (
                <DialerColumns onFilter={onFilter} />
            ) : (
                outreachTypes.map(type => {
                    if (type === "dialer") {
                        return <DialerColumns onFilter={onFilter} key={type} />
                    }
                    if (type === "text") {
                        return <TextColumns onFilter={onFilter} key={type} hasCall={outreachTypes.includes("dialer")} />
                    }
                    return null;
                }).filter(Boolean)
            )}
            <SemanticTable.HeaderCell width={2}>
                <ClearableCheckboxDropdown
                    text="Status"
                    name="status"
                    onChange={(_, { value }) => {
                        onFilterByStatus(value);
                    }}
                    onRead={() => {}}
                    value={params.get("status")?.split(",")}
                    options={[
                        { key: "active", value: "active", text: "Active" },
                        { key: "inactive", value: "inactive", text: "Inactive" },
                    ]}
                    closeOnLoad
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={1}>
                Actions
            </SemanticTable.HeaderCell>
        </Table.Row>
    );
};
